import { Component } from '@angular/core'
import { BaseComponent } from '../../components/base.component'

@Component({
    selector: 'app-layout',
    templateUrl: './app-layout.component.html',
    styleUrl: './app-layout.component.scss',
    standalone: false
})
export class AppLayoutComponent extends BaseComponent {


  isLoggedIn: boolean = false;
  isMenuCollapsed = true;

  constructor() {
    super()
  }

}
